// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_FIRTS_OF_COLUMN = false;
export const DEFAULT_FIRST_OF_ROW = false;
export const DEFAULT_IS_SECTION = false;
